import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const TextSpanWithForwardedRef = ({
  classes, node, forwardedRef,
}) => {
  let textContainerClassNames = [classes.textContainer];

  if (node.entityType === 'AdGroup') {
    textContainerClassNames.push(classes.leafNodeTextContainer);
  }

  if (node.status === 'Paused') {
    textContainerClassNames = textContainerClassNames.concat([
      classes.pausedTextContainer,
      'main-menu-tree-node-paused-text']);
  } else {
    textContainerClassNames.push('main-menu-tree-node-active-text');
  }

  return (
    <span
      className={classNames(textContainerClassNames)}
      ref={forwardedRef}
    >
      {node.name}
    </span>
  );
};

TextSpanWithForwardedRef.propTypes = {
  classes: PropTypes.shape({
    textContainer: PropTypes.string.isRequired,
    leafNodeTextContainer: PropTypes.string.isRequired,
    pausedTextContainer: PropTypes.string.isRequired,
  }).isRequired,
  node: PropTypes.shape({
    name: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    status: PropTypes.string,
  }).isRequired,
  forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

TextSpanWithForwardedRef.defaultProps = {
  forwardedRef: null,
};
